export default __webpack_public_path__ + "1660f6df30453dbb848cdf96ceb7dc64.png";